import { LitElement, html, css, classMap } from '@hh/global.js'

class CopyClipboard extends LitElement {
  static properties = {
    link: {
      type: String,
    },
    isCopied: {
      type: Boolean
    }
  }

  constructor() {
    super()
    this.isCopied = false
    this.shareButton = this.querySelector('button')
    this.shareButton.addEventListener('click', this.copyToClipboard.bind(this))
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.link).then(() => {
      this.isCopied = true

      setTimeout(() => {
        this.isCopied = false
      }, 2500)
    })
  }

  static styles = css`
    .container {
      position: relative;
      font: var(--theme-body-font);
      font-size: 12px;
    }

    .tooltip {
      position: absolute;
      padding: 4px 6px;
      top: -150%;
      left: 15%;
      background-color: var(--theme-color-ink);
      color: var(--theme-color-reverse);
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      transform: translateX(-50%);
      transition: all 250ms ease;
    }

    .is-copied .tooltip {
      opacity: 1;
      visibility: visible;
    }
  `

  render() {
    const addClass = classMap({ 'is-copied': this.isCopied })

    return html`<div class="container ${addClass}">
      <div class="tooltip" aria-live="polite">Link copied!</div>
      <div>
        <slot></slot>
      </div>
    </div>`
  }
}

customElements.define('copy-clipboard', CopyClipboard)
